
<div
    class  = "w-100 lm-border pa-2"
    style  = "height: 216px;"
>
    <div class="primary white--text" style="border-bottom-style: solid; border-bottom-width: 1px; font-size: 15px; font-weight: 500; height: 24px; padding-left: 4px; padding-top: 1px">
        {{ title }}
    </div>
    <div class="v-flex mt-2" style="min-height: 36px;">
        <f-enum-select
            v-model       = "tzbComponent.modernization"
            :label        = "$t('unit.tzb.modernization.measure')"
            class         = "measure-type"
            module        = "msd"
            type          = "tzbModernizationType"
            :readonly     = "readonly"
            :hide-details = "true"
        />
        <f-currency-field
            v-if          = "tzbComponent.modernization && tzbComponent.modernization.id !== 1"
            :label        = "$t('unit.tzb.modernization.costs')"
            v-model       = "tzbComponent.costs"
            class         = "money measure-costs"
            :hide-details = "true"
            :readonly     = "readonly"
        />
    </div>

    <div class = "measure-note">
        <v-textarea
            :label         = "$t('unit.tzb.modernization.note')"
            v-model        = "tzbComponent.note"
            rows           = "3"
            autocomplete   = "off"
            autocorrect    = "off"
            autocapitalize = "off"
            spellcheck     = "false"
            hide-details   = "true"
            :readonly      = "readonly"
            no-resize
        />
    </div>
</div>
